// extracted by mini-css-extract-plugin
export default {"title":"SendSuccess_title__t2wzs","secondary":"SendSuccess_secondary__cTkT4","action":"SendSuccess_action__SgnAH"};